<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Delete Safety Meeting :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/safety-meetings`">
                            <i class="fa fa-life-ring"></i> Safety Meeting
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/safety-meetings/view/${meeting.safety_meeting_id}`">
                            Meeting on {{ meeting.meeting_date | moment("MM/DD/YYYY") }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">Delete</li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-8 col-lg-10 col-md-12">
                    <div class="card">
                        <div class="card-header">Delete Safety Meeting</div>
                        <div class="card-body">
                            <div class="alert alert-danger">
                                <strong>Warning:</strong> You are about to delete this safety meeting. This will delete all files and attendees. This cannot be undone.
                            </div>
                        </div>
                        <div class="card-footer">
                            <button type="button" class="btn btn-sm btn-danger" v-on:click="deleteMeeting()" :disabled="deleting">
                                <template v-if="!deleting">
                                    Delete Safety Meeting
                                </template>
                                <template v-else>
                                    Deleting...
                                </template>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                deleting: false,
                safety_meeting_id: this.$route.params.id,
                meeting: {},
                errors: {},
            }
        },

        methods: {

            getSafetyMeeting: function() {
                //Get the data
                this.$http
                    .get('safety-meetings/edit/' + this.safety_meeting_id)
                    .then(response => {
                        //Set all the data
                        this.meeting = response.data.meeting;
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Set loading
                        this.loading = false;
                    });
            },

            deleteMeeting: function() {
                //SHow loading
                this.deleting = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('safety-meetings/delete/' + this.safety_meeting_id)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Safety Meeting Deleted');

                    //Return to main list?
                    this.$router.push('/safety-meetings');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.deleting = false;
                });
            },
        },

        mounted() {
            //Get the Safety Meeting
            this.getSafetyMeeting();
        }
    }
</script>
